import { xMedian } from "../x/index.js";
import { matrixToArray } from "./matrixToArray.js";
/**
 * Returns the median of the matrix.
 * @param matrix - input matrix.
 */
export function matrixMedian(matrix) {
    return xMedian(matrixToArray(matrix));
}
//# sourceMappingURL=matrixMedian.js.map